import { render } from "./FilePlayerDialog.vue?vue&type=template&id=2b34f2e3&scoped=true"
import script from "./FilePlayerDialog.vue?vue&type=script&lang=js"
export * from "./FilePlayerDialog.vue?vue&type=script&lang=js"

import "./FilePlayerDialog.vue?vue&type=style&index=0&id=2b34f2e3&scoped=true&lang=css"

import exportComponent from "/Users/durul/Downloads/projects/backend/validationVue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b34f2e3"]])

export default __exports__